import { oauthProviderClient } from "@better-auth/oauth-provider/client";
import { ssoClient } from "@better-auth/sso/client";
import { organizationClient } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";

// Same-origin in production; in dev, Vite proxies /api to the Worker so cookies
// stay first-party. VITE_API_URL can override for a split deployment.
const baseURL =
  (import.meta.env.VITE_API_URL as string | undefined) ||
  (typeof window !== "undefined" ? window.location.origin : "http://localhost:8787");

export const authClient = createAuthClient({
  baseURL,
  plugins: [organizationClient(), ssoClient(), oauthProviderClient()],
});

export const { signIn, signUp, signOut, useSession } = authClient;
